import React from "react";
import "./Nav.css";
import requests from "../requests";

const Nav = ({setSelectedOption}) =>{
    return(
        <div className="nav">
            <h2 onClick={()=> setSelectedOption(requests.fetchTranding)}>Trending</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchActionMovies)}>Action</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchComedyMovies)}>Comedy</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchHorrorMovies)}>Horror</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchRomanceMovies)}>Romance</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchDocumentaries)}>Documentaries</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchWestern)}>Western</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchAnimation)}>Animation</h2>
            <h2 onClick={()=> setSelectedOption(requests.fetchTv)}>Movie</h2>
        </div>
    );
}

export default Nav;